export default __webpack_public_path__ + "static/media/ico_project_share.36c4bb96.svg";